"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
var _humanizeList = _interopRequireDefault(require("humanize-list"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var overrides = {
  'Emergency Ambulance': 'Ambulance - emergency'
};
var getCombinedServiceName = function getCombinedServiceName(services) {
  var names = _lodash["default"].map(services, 'name');
  var caseSensitiveNames = (0, _lodash["default"])(services).filter('isNameCaseSensitive').map('name').value();
  var _partition = (0, _fp.partition)(function (name) {
      return (0, _fp.includes)('dental', name);
    }, names),
    _partition2 = _slicedToArray(_partition, 2),
    dentalItems = _partition2[0],
    nonDentalItems = _partition2[1];
  var dentalItem = (0, _lodash["default"])(dentalItems).sortBy().map(function (name) {
    return (0, _fp.reject)(function (word) {
      return word === 'dental';
    }, (0, _fp.words)(name)).join(' ');
  }).map(_fp.lowerCase).thru(_humanizeList["default"]).thru(function (joinedName) {
    return (0, _fp.size)(joinedName) ? "Dental - ".concat(joinedName) : null;
  }).value();
  return (0, _lodash["default"])(nonDentalItems).concat(dentalItem).compact().map(function (name, index) {
    if (index === 0) {
      return name;
    }
    return (0, _fp.includes)(name, caseSensitiveNames) ? name : (0, _fp.toLower)(name);
  }).map(function (item) {
    return (0, _fp.getOr)(item, item, overrides);
  }).thru(_humanizeList["default"]).value();
};
var _default = exports["default"] = getCombinedServiceName;
module.exports = exports.default;